import { useRef } from 'react';
import { SECTION_IDS, site } from '../content/site';
import { gsap, useGSAP, EASE, MOTION_OK } from '../lib/gsap';
import { HorizontalAccordion } from '../components/expertise/HorizontalAccordion';
import { VerticalAccordion } from '../components/expertise/VerticalAccordion';
import { useMediaQuery } from '../components/expertise/useMediaQuery';

const TITLE_ID = 'expertise-title';

/**
 * Expertises: gpt-taste "Horizontal Accordion" from 1024px (four slices, one open),
 * a vertical accordion below. No eyebrow on this section (the page keeps three).
 */
export function Expertise() {
	const ref = useRef<HTMLElement>(null);
	const wide = useMediaQuery('(min-width: 1024px)');
	const { title, items } = site.expertise;

	useGSAP(
		() => {
			const mm = gsap.matchMedia();
			mm.add(MOTION_OK, () => {
				gsap.from(`#${TITLE_ID}`, {
					y: 28,
					opacity: 0,
					duration: 1.1,
					ease: EASE,
					scrollTrigger: { trigger: ref.current, start: 'top 78%', once: true },
				});
			});
		},
		{ scope: ref },
	);

	return (
		<section id={SECTION_IDS.expertise} ref={ref} aria-labelledby={TITLE_ID} className="section-pad">
			<div className="container-site">
				<h2
					id={TITLE_ID}
					className="max-w-[17ch] text-balance font-display text-[clamp(2.25rem,4.6vw,4.5rem)] font-bold leading-[1] tracking-[-0.035em] text-graphite dark:text-mineral"
				>
					{title}
				</h2>
				<div className="mt-12 md:mt-16 lg:mt-20">
					{wide ? <HorizontalAccordion items={items} /> : <VerticalAccordion items={items} />}
				</div>
			</div>
		</section>
	);
}
